import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LoginService } from '../login-service/login.service';

const LOGO_STORAGE_KEY = 'APP_LOGO_URL';

@Injectable({
  providedIn: 'root'
})
export class LogoService {
  private logoSubject = new BehaviorSubject<string | null>(null);
  logo$ = this.logoSubject.asObservable();

  constructor(private loginService: LoginService) {
    this.initLogo();
  }

  private initLogo() {
    const storedLogo = localStorage.getItem(LOGO_STORAGE_KEY);

    if (storedLogo) {
      this.logoSubject.next(storedLogo);
    }

    this.loadLogoFromApi();
  }

  private loadLogoFromApi() {
    this.loginService.getWebSiteLogo().subscribe({
      next: (res) => {
        const logoUrl = res?.logo?.fileUrl ?? null;
        if (logoUrl) {
          this.logoSubject.next(logoUrl);
          localStorage.setItem(LOGO_STORAGE_KEY, logoUrl);
        }
      },
      error: (err) => {
        console.error('Error loading logo:', err);
      }
    });
  }

  getLogo(): string | null {
    return this.logoSubject.getValue();
  }
}
